// Registra o service worker apenas em produção e faz o "update silencioso":
// quando uma versão nova assume o controle, recarrega a página UMA vez.
// Não recarrega na primeira instalação (sem controller anterior) nem entra
// em loop (flag em memória; após o reload o novo SW já é o controller).
export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const hadController = !!navigator.serviceWorker.controller;

    // Nome próprio (não "service-worker.js"): o react-scripts 3.x gera um SW
    // Workbox (precache/cache-first) chamado service-worker.js no build, que
    // reintroduziria o "preso em versão antiga". Registrando o nosso por outro
    // nome, o Workbox fica órfão (ninguém o registra) e vale o network-first.
    navigator.serviceWorker
      .register('/app-sw.js')
      .catch((err) => console.error('Falha ao registrar o service worker:', err));

    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return; // evita reload duplo
      if (!hadController) return; // primeira instalação: não recarrega
      refreshing = true;
      window.location.reload();
    });
  });
}
